export default "__VITE_ASSET__D9Mwi2Na__";